import { render, staticRenderFns } from "./v-select-basic.vue?vue&type=template&id=7edb4f0e&scoped=true&"
import script from "./v-select-basic.vue?vue&type=script&lang=js&"
export * from "./v-select-basic.vue?vue&type=script&lang=js&"
import style0 from "./v-select-basic.vue?vue&type=style&index=0&id=7edb4f0e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edb4f0e",
  null
  
)

export default component.exports